import { render } from "./PsychologyFactLoader.vue?vue&type=template&id=383e04d6&scoped=true"
import script from "./PsychologyFactLoader.vue?vue&type=script&lang=js"
export * from "./PsychologyFactLoader.vue?vue&type=script&lang=js"

import "./PsychologyFactLoader.vue?vue&type=style&index=0&id=383e04d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383e04d6"]])

export default __exports__